import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";
import { StbCustomRenderButtonComponent } from "../smart-table-customs/custom-render-button";
import { Purchase } from "../../models/purchase.model";
import { StbCustomRenderDateComponent } from "../smart-table-customs/custom-render-date";
import { StbCustomRenderIdComponent } from "../smart-table-customs/custom-render-id";
import { StbCustomRenderCheckboxComponent } from "../smart-table-customs/custom-render-checkbox";

@Component({
  selector: "ngx-view-table-purchases",
  styleUrls: ["./view-table-purchases.component.scss"],
  templateUrl: "./view-table-purchases.component.html",
})
export class ViewTablePurchasesComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() purchases?: Purchase[] = [];
  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isEditing = false;

  strSearch = "";
  uid = "anonymous";

  //ng2-smart-table config
  @Input() source: LocalDataSource = new LocalDataSource();
  settings = {};

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }

          this.settings = {
            hideHeader: false,
            noDataMessage:
              user.language == "en" ? "Empty data" : "Không có dữ liệu",
            attr: {
              class: "table table-striped",
            },
            actions: {
              columnTitle: "",
              add: false,
              edit: false,
              delete: false,
            },
            columns: {
              issueDate: {
                title: user.language == "en" ? "Date" : "Ngày",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderDateComponent,
              },
              id: {
                title: user.language == "en" ? "Code" : "Số phiếu",
                type: "custom",
                renderComponent: StbCustomRenderIdComponent,
              },
              supplierName: {
                title: user.language == "en" ? "Supplier" : "Nhà cung cấp",
                type: "string",
              },
              supplierMobile: {
                title: user.language == "en" ? "Mobile" : "Di động",
                type: "string",
              },
              totalAmount: {
                title: user.language == "en" ? "Amount" : "Tổng tiền",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              isDebit: {
                title: user.language == "en" ? "Debit" : "Nợ?",
                type: "custom",
                renderComponent: StbCustomRenderCheckboxComponent,
                filter: {
                  type: "checkbox",
                  config: {
                    true: "true",
                    false: "false",
                    resetText: "Xóa",
                  },
                },
              },
              note: {
                title: user.language == "en" ? "Note" : "Ghi chú",
                type: "string",
              },
              status: {
                title: user.language == "en" ? "Status" : "Trạng thái",
                filter: {
                  type: "list",
                  config: {
                    selectText: user.language == "en" ? "Choose..." : "Chọn...",
                    list: [
                      {
                        value: "Đang thực hiện",
                        title:
                          user.language == "en"
                            ? "Inprogress"
                            : "Đang thực hiện",
                      },
                      {
                        value: "Đóng phiếu",
                        title: user.language == "en" ? "Closed" : "Đóng phiếu",
                      },
                      {
                        value: "In",
                        title:
                          user.language == "en"
                            ? "Print & Closed"
                            : "In và đóng phiếu",
                      },
                      {
                        value: "Mở lại phiếu",
                        title:
                          user.language == "en" ? "Re-open" : "Mở lại phiếu",
                      },
                      { value: "Hủy", title: "Hủy" },
                    ],
                  },
                },
              },
            },
          };

          this.source.load(this.purchases);
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //smart-table events
  selectedItem(event): void {
    const item = event.data;
    this.onSelectedItem.emit(item);
  }
}
